/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  SERVICES_ADD_REQUEST,
  SERVICES_ADD_REQUEST_SUCCESS,
  SERVICES_ADD_REQUEST_FAILURE,
  SERVICES_FETCH_REQUEST,
  SERVICES_FETCH_REQUEST_SUCCESS,
  SERVICES_FETCH_REQUEST_FAILURE,
  SERVICES_UPSERT_REQUEST,
  SERVICES_UPSERT_REQUEST_SUCCESS,
  SERVICES_UPSERT_REQUEST_FAILURE,
  SERVICES_DELETE_REQUEST,
  SERVICES_DELETE_REQUEST_SUCCESS,
  SERVICES_DELETE_REQUEST_FAILURE,
  SERVICES_FETCH_DROPDOWN_REQUEST,
  SERVICES_FETCH_DROPDOWN_REQUEST_SUCCESS,
  SERVICES_FETCH_DROPDOWN_REQUEST_FAILURE,
  SERVICES_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  servicesPayload: [],
  servicesLoading: false,
  servicesErrors: {},
  dropdownPayload: [],
  dropdownLoading: false,
  dropdownErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const serviceReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SERVICES_UPSERT_REQUEST:
    case SERVICES_ADD_REQUEST:
    case SERVICES_DELETE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SERVICES_UPSERT_REQUEST_SUCCESS:
    case SERVICES_ADD_REQUEST_SUCCESS:
    case SERVICES_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case SERVICES_UPSERT_REQUEST_FAILURE:
    case SERVICES_ADD_REQUEST_FAILURE:
    case SERVICES_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SERVICES_FETCH_REQUEST:
      return Object.assign({}, state, {
        servicesLoading: true,
      });

    case SERVICES_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        servicesLoading: false,
        servicesPayload: action.data,
        servicesErrors: {},
      });

    case SERVICES_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        servicesLoading: false,
        servicesErrors: action.error,
      });

    case SERVICES_FETCH_DROPDOWN_REQUEST:
      return Object.assign({}, state, {
        dropdownLoading: true,
      });

    case SERVICES_FETCH_DROPDOWN_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        dropdownLoading: false,
        dropdownPayload: action.data,
        dropdownErrors: {},
      });

    case SERVICES_FETCH_DROPDOWN_REQUEST_FAILURE:
      return Object.assign({}, state, {
        dropdownLoading: false,
        dropdownErrors: action.error,
      });

    case SERVICES_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        servicesLoading: false,
        servicesErrors: {},
        dropdownLoading: false,
        dropdownErrors: {},
      });
    default:
      return state;
  }
};

export default serviceReducer;
